/**
 * Created by mzietek on 2016-11-23.
 */

(function(){

    angular
        .module('repairforms.directive.module')
        .directive('inputDateSymbolsOnly', inputDateSymbolsOnly);

    /**
     * allows only digitals to be inserted into input
     * **/

    function inputDateSymbolsOnly () {
        return {
            require: 'ngModel',
            link: function (scope, element, attr, ngModelCtrl) {
                function fromUser(text) {
                    var transformedInput = text.replace(/[^0-9.]*/g, '');
                    if(transformedInput !== text) {
                        ngModelCtrl.$setViewValue(transformedInput);
                        ngModelCtrl.$render();
                    }
                    return transformedInput;
                }
                ngModelCtrl.$parsers.push(fromUser);
            }
        };
    }

})();